import { render, staticRenderFns } from "./OpenInvoice.vue?vue&type=template&id=739e074a&scoped=true&lang=pug"
import script from "./OpenInvoice.vue?vue&type=script&lang=js"
export * from "./OpenInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739e074a",
  null
  
)

export default component.exports